import React from 'react';

const CopyIcon = (props) => {
  return (
    <svg width='24' height='24'  viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0h24v24H0z' />
        <path stroke='var(--theme-primary, #810ea9)' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' d='M20.25 17.25V3.75H6.748' />
        <path stroke='#000' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' d='M3.749 6.75H17.25v13.5H3.749z' />
      </g>
    </svg>
  );
};

export default CopyIcon;
